<template>
    <div v-if="shouldMock">
        <v-speed-dial
            class="mr-6 mt-n2"
            v-model="fab"
            absolute
            top
            right
            direction="bottom"
            transition="slide-y-reverse-transition"
        >
            <template v-slot:activator>
                <v-btn v-model="fab" color="warning darken-2" dark fab>
                    <v-icon v-if="fab"> mdi-close </v-icon>
                    <v-icon v-else> mdi-text-account </v-icon>
                </v-btn>
            </template>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        dark
                        color="accent darken-1"
                        @click="getImports"
                        v-on="on"
                        v-bind="attrs"
                    >
                        <v-icon>mdi-file-import</v-icon>
                    </v-btn>
                </template>
                <span>Get Test Applicant Imports</span>
            </v-tooltip>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        dark
                        color="primary"
                        @click="viewDialog = true"
                        v-on="on"
                        v-bind="attrs"
                    >
                        <v-icon>mdi-file-eye</v-icon>
                    </v-btn>
                </template>
                <span>View Current Screening Details</span>
            </v-tooltip>
        </v-speed-dial>
        <v-dialog v-model="dialog" width="640">
            <psi-dialog
                title="Imported Applicants"
                v-if="dialog"
                @close="
                    dialog = false;
                    selected = [];
                "
            >
                <v-data-table
                    height="250"
                    single-select
                    item-key="applicant_id"
                    v-model="selected"
                    disable-pagination
                    hide-default-footer
                    show-select
                    :headers="headers"
                    :loading="dataLoading"
                    :items="applicantImports"
                    @item-selected="itemSelect"
                >
                </v-data-table>

                <template v-slot:actions>
                    <v-btn
                        class="mr-4"
                        @click.stop="
                            dialog = false;
                            selected = [];
                        "
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="selected.length === 0"
                        color="accent"
                        class="px-4"
                        @click.stop="importSelected"
                    >
                        <v-icon class="mr-1">mdi-file-import</v-icon>
                        Import
                    </v-btn>
                </template>
            </psi-dialog>
        </v-dialog>

        <v-dialog v-model="viewDialog" fullscreen persistent>
            <psi-dialog
                v-if="viewDialog"
                icon="mdi-account-box"
                title="View Screening Data"
                @close="viewDialog = false"
                hide-actions
            >
                <json-viewer
                    v-if="Object.keys(currentScreen).length"
                    :value="$_.get(currentScreen, 'screen', {})"
                    boxed
                    expanded
                    :expand-depth="5"
                ></json-viewer>
            </psi-dialog>
        </v-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Mocking from "@/mixins/mocking";
export default {
    name: "order-test-toolbar",
    mixins: [Mocking],
    components: {},
    props: {},
    data() {
        return {
            fab: false,
            dialog: false,
            viewDialog: false,
            selected: [],

            headers: [
                {
                    text: "Name",
                    align: "start",
                    sortable: true,
                    value: "name",
                },
                {
                    text: "ID",
                    align: "start",
                    sortable: true,
                    value: "applicant_id",
                },
            ],
        };
    },
    computed: {
        ...mapGetters("Screens", [
            "applicantImports",
            "dataLoading",
            "currentScreen",
        ]),
    },
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {
        ...mapActions("Screens", ["getApplicantImports", "importApplicant"]),
        getImports() {
            this.dialog = true;
            this.getApplicantImports();
        },
        itemSelect(item) {
            console.log(item);
        },
        importSelected() {
            this.importApplicant({
                applicantId: this.selected[0].applicant_id,
                applicantData: this.selected[0].import,
            });
        },
    },
};
</script>

<style scoped>
</style>
 
 